'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _home = require('./home');

var _home2 = _interopRequireDefault(_home);

var _dancers = require('./dancers');

var _dancers2 = _interopRequireDefault(_dancers);

var _organizers = require('./organizers');

var _organizers2 = _interopRequireDefault(_organizers);

var _teachers = require('./teachers');

var _teachers2 = _interopRequireDefault(_teachers);

var _dashboard = require('./dashboard');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _errors = require('./errors');

var _errors2 = _interopRequireDefault(_errors);

var _login = require('./login');

var _login2 = _interopRequireDefault(_login);

var _admin = require('./admin');

var _admin2 = _interopRequireDefault(_admin);

var _feiseanna = require('./feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _account = require('./account');

var _account2 = _interopRequireDefault(_account);

var _results = require('./results/results.module');

var _results2 = _interopRequireDefault(_results);

var _routerHistory = require('../router-history');

var _routerHistory2 = _interopRequireDefault(_routerHistory);

var _privacy = require('./privacy');

var _privacy2 = _interopRequireDefault(_privacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes', ['ui.router', 'ncy-angular-breadcrumb', 'ifeis.router-history', 'ifeis.routes.home', 'ifeis.routes.dancers', 'ifeis.routes.organizers', 'ifeis.routes.teachers', 'ifeis.routes.dashboard', 'ifeis.routes.errors', 'ifeis.routes.login', 'ifeis.routes.admin', 'ifeis.routes.feiseanna', 'ifeis.routes.account', 'ifeis.routes.results', 'ifeis.routes.privacy']).config(function ($urlRouterProvider, $locationProvider, $breadcrumbProvider) {
  $locationProvider.html5Mode(true);
  $urlRouterProvider.otherwise('/not-found');

  $breadcrumbProvider.setOptions({
    template: '<ul class="f-breadcrumbs" layout="row">\n        <li ng-repeat="step in steps | limitTo:(steps.length-1)" class="f-note">\n          <a href="{{ step.ncyBreadcrumbLink }}">{{ step.ncyBreadcrumbLabel }}</a><span class="f-breadcrumbs-divider">/</span>\n        </li>\n        <li ng-repeat="step in steps | limitTo:-1" class="active f-note">\n          <span>{{ step.ncyBreadcrumbLabel }}</span>\n        </li>\n      </ul>'
  });
}).run(function ($rootScope, $state, fRouterHistoryService) {
  $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
    if (!from.abstract) {
      fRouterHistoryService.save(from.name, fromParams);
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/index.js
// module id = 455
// module chunks = 0